/* global angular, TweenMax */
angular.module('ua5App')
    .directive('modal', [function() {
        return {
            restrict: 'A',
            scope: {
                modalClose: '='
            },
            link: function($scope, element, attrs) {
                var animation;
                animation = TweenMax.fromTo(element, 0.2, {
                    alpha: 0
                }, {
                    alpha: 1,
                    onReverseComplete: function() {
                        $scope.modalClose();
                    }
                });
                $scope.$on('modal:closed', function(e, close) {
                    animation.reverse();
                });
                $scope.$on('app:escapePressed', function() {
                    animation.reverse();
                });
            }
        };
    }])
;
